import React from 'react';
import { FiSearch } from "react-icons/fi";

const CustomSearch = ({
  handleSearchSubmit,
  handleSearchChange,
  searchTerm,
  placeholder = "Search...",
  className = ""
}) => {
  return (
    <form
      onSubmit={handleSearchSubmit}
      className={`relative w-full md:w-[385px] ${className}`}
    >
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleSearchChange}
        className="w-full pl-4 pr-14 h-[50px] border border-gray-300 rounded-[10px] shadow-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-customGreen"
      />
      <button
        type="submit"
        className="absolute right-0 top-0 h-[50px] w-[50px] bg-customGreen text-white rounded-r-[10px] flex items-center justify-center hover:bg-green-600 transition"
      >
        <FiSearch size={20} />
      </button>
    </form>
  );
};

export default CustomSearch;
